import { render, staticRenderFns } from "./IntroFooter.vue?vue&type=template&id=69ed77ea&scoped=true"
import script from "./IntroFooter.vue?vue&type=script&lang=js"
export * from "./IntroFooter.vue?vue&type=script&lang=js"
import style0 from "./IntroFooter.vue?vue&type=style&index=0&id=69ed77ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ed77ea",
  null
  
)

export default component.exports